import styled from 'styled-components';

import {
	betweenWidths,
	Colors,
	fontSize,
	FontSizes,
	lineHeight,
	maxWidth,
	minWidth,
	Text,
	units,
} from '@calm-web/design-system';

export const Container = styled.div`
	overflow: hidden;
	height: ${units(95)};
	position: relative;

	${betweenWidths('mobileLarge', 'desktop')} {
		height: 100vh;
	}

	${maxWidth('mobileLarge')} {
		height: ${units(105)};
	}
`;

export const Overlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.3);
	width: 100%;
	height: ${units(95)};

	${betweenWidths('mobileLarge', 'desktop')} {
		height: 100vh;
	}

	${maxWidth('mobileLarge')} {
		height: ${units(105)};
	}
`;

export const Wrapper = styled.div`
	position: absolute;
	margin-top: 10vh;
	width: 100%;
	top: 0;
`;

export const RedeemItemsWrapper = styled.div`
	align-items: center !important;
	display: flex;
	margin: ${units(15)} auto ${units(10)};
	position: relative;

	${minWidth('desktop')} {
		width: ${units(110)};
	}

	${minWidth('tablet')} {
		align-items: flex-start;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	${maxWidth('tablet')} {
		flex-direction: column;
		align-items: center;
	}

	${betweenWidths('tablet', 'desktop')} {
		width: calc(100% - ${units(15)});
	}

	${betweenWidths('mobileLarge', 'desktop')} {
		margin-top: ${units(5)};
		margin-bottom: 0;
		width: ${units(50)};
	}

	${maxWidth('mobileLarge')} {
		margin-top: ${units(5)};
		margin-bottom: 0px;
		width: calc(100% - ${units(4)});
	}
`;

export const Column = styled.div<{ mobileOrder: number }>`
	${maxWidth('desktop')} {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		width: 100%;

		${props => (props.mobileOrder ? `order: ${props.mobileOrder};` : '')};
		${props =>
			props.mobileOrder === 1 || props.mobileOrder === undefined
				? ''
				: `
            &:nth-child(1) {
                margin: ${units(5)} 0;
            }
            `}
		${props =>
			props.mobileOrder === 2
				? `
            &:nth-child(1) {
                margin: ${units(5)} 0;
            }
            `
				: ''}
	}

	${minWidth('desktop')} {
		width: ${units(50)};
	}
`;

export const RedeemColumn = styled(Column)`
	background-color: ${Colors.white};
	border-radius: ${units(2)};
	box-sizing: border-box;
	padding: ${units(4.5)};
	text-align: center;
	color: ${Colors.black};

	${maxWidth('mobileLarge')} {
		padding: ${units(3)};
	}
`;

export const GuestPassImageColumn = styled(Column)`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
`;

export const ClaimYourPassText = styled(Text)`
	color: ${Colors.white};
	${fontSize(1.75)};
	${lineHeight(1.75)};
`;

export const GuestPassTitle = styled(Text)`
	${fontSize(1.5)};
	margin-bottom: ${units(5)};

	${maxWidth('desktop')} {
		margin-bottom: 0;
	}
`;

export const GuestPassText = styled.div`
	${fontSize(FontSizes.base)};
	margin: ${units(3)} 0;
`;

export const TermsText = styled.div`
	${fontSize(FontSizes.sm)};
	text-align: center;
	margin-top: ${units(3)};
	margin-bottom: ${units(1)};
	width: 100%;
`;

export const Link = styled.a`
	font-weight: bold;
	text-decoration: underline;
`;

export const GuestPassImage = styled.div`
	max-width: ${units(40)};
`;
